import { Reducer } from 'redux'

import { DocumentosAssinaturaTypes, DocumentosAssinaturaState } from './types'

const INITIAL_STATE: DocumentosAssinaturaState = {
  documentos: [],
  idIteracao: '',
  documentoRevisao: 'SEGURO_PRESTAMISTA_REFINANCIAMENTO',
  checkMessageRevisao: '',
  loading: false,
  tituloDocumentoRevisao: '',
  loadingFinalizarProposta: false,
  erroFinalizarProposta: false,
  propostaFinalizada: false,
}

const reducer: Reducer<DocumentosAssinaturaState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case DocumentosAssinaturaTypes.SET_DOCUMENTOS:
      return { ...state, documentos: action.payload }
    case DocumentosAssinaturaTypes.SET_ID_ITERACAO:
      return { ...state, idIteracao: action.payload }
    case DocumentosAssinaturaTypes.SET_DOCUMENTO_REVISAO:
      return { ...state, documentoRevisao: action.payload }
    case DocumentosAssinaturaTypes.SET_CHECK_MESSAGE_REVISAO:
      return { ...state, checkMessageRevisao: action.payload }
    case DocumentosAssinaturaTypes.SET_TITLE_DOCUMENTO_REVISAO:
      return { ...state, tituloDocumentoRevisao: action.payload }
    case DocumentosAssinaturaTypes.RESET:
      return { ...INITIAL_STATE }
    case DocumentosAssinaturaTypes.SET_LOADING:
      return { ...state, loading: action.payload }
    case DocumentosAssinaturaTypes.FINALIZAR_PROPOSTA:
      return {
        ...state,
        loadingFinalizarProposta: true,
        erroFinalizarProposta: false,
        propostaFinalizada: false,
      }
    case DocumentosAssinaturaTypes.FINALIZAR_PROPOSTA_ERROR:
      return {
        ...state,
        loadingFinalizarProposta: false,
        erroFinalizarProposta: true,
        propostaFinalizada: false,
      }
    case DocumentosAssinaturaTypes.FINALIZAR_PROPOSTA_SUCCESS:
      return {
        ...state,
        loadingFinalizarProposta: false,
        erroFinalizarProposta: false,
        propostaFinalizada: true,
      }
    default:
      return state
  }
}

export default reducer
